import { Typography } from '@navi/web-ui/lib/primitives';
import styles from './index.module.scss';
import { useNavigate } from 'react-router-dom';
import { createQueryParams, readQueryParams } from '@cp/src/utils/QueryParamsHelper';
import dayjs from 'dayjs';
import { DateFormat } from '@cp/src/utils/DateHelper';
import cx from 'classnames';
import MockStatusIndicator from './MockStatusIndicator';
import { FIELD_ALLOCATION_KEY } from '../../types';
import { IMockRun } from '../../interface';
import { getMockId } from '../RightPanel/utils';
import { addClickstreamEvent } from '@cp/src/service/clickStreamEventService';
import { SELF_SERVE_UI_CLICKSTREAM } from '@cp/src/service/clickStream.constant';

interface IMockCard {
  mockRun: IMockRun;
  mockNumber: number;
}

const MockCard = ({ mockRun, mockNumber }: IMockCard) => {
  const navigate = useNavigate();
  const queryParams = readQueryParams();
  const mockId = mockRun?.allocationTrackerId;

  const isMockSelected = queryParams[FIELD_ALLOCATION_KEY]?.selectedId === mockId;

  const handleMockCardClick = () => {
    if (isMockSelected) return;
    addClickstreamEvent(SELF_SERVE_UI_CLICKSTREAM.LH_MOCK_RUN_CARD_CLICKED, {
      mockId: mockId,
      mockStatus: mockRun?.status?.value
    });
    const updatedTableParams = { ...queryParams };
    updatedTableParams[FIELD_ALLOCATION_KEY] = {
      ...queryParams[FIELD_ALLOCATION_KEY],
      selectedId: mockId
    };
    const url = createQueryParams(updatedTableParams);
    navigate(url, { replace: true });
  };

  return (
    <div
      className={cx(styles.mockRunCard, {
        [styles.selected]: isMockSelected
      })}
      onClick={handleMockCardClick}
    >
      <div className="flex justify-between">
        <Typography variant="h4" color="var(--light-grayscale-content-2)">
          {mockNumber}. {getMockId(mockId)}
        </Typography>
        <MockStatusIndicator status={mockRun.status} />
      </div>
      <div className="flex items-center justify-between mt-4">
        <div>
          <Typography variant="h6" className="text-[10px]" color="var(--navi-color-gray-c3)">
            Initiated at
          </Typography>
          <Typography variant="h4" className="text-[12px]" color="var(--light-grayscale-content-2)">
            {mockRun?.initiatedAt
              ? dayjs.unix(mockRun.initiatedAt).format(DateFormat.DD_MMM_hh_mm_A)
              : '-'}
          </Typography>
        </div>
        <div>
          <Typography variant="h6" className="text-[10px]" color="var(--navi-color-gray-c3)">
            Mock triggered at
          </Typography>
          <Typography variant="h4" className="text-[12px]" color="var(--light-grayscale-content-2)">
            {mockRun?.mockTriggeredAt
              ? dayjs.unix(mockRun.mockTriggeredAt).format(DateFormat.DD_MMM_hh_mm_A)
              : '-'}
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default MockCard;
